// Gradient circle class names (styles defined in CSS)
const GRADIENT_CIRCLES = ["blob-1", "blob-2", "blob-3", "blob-4", "blob-5"];

export const animatedGradient = () => ({
  // Animation state
  curX: 0,
  curY: 0,
  tgX: 0,
  tgY: 0,
  interactiveElement: null,
  animationFrameId: null,
  mouseMoveHandler: null,
  gradientContainer: null,

  init() {
    // Create all gradient HTML structure
    this.createGradientStructure();

    // Find the interactive bubble element
    this.interactiveElement = this.$el.querySelector(".interactive");

    // Safety check: stop if element doesn't exist
    if (!this.interactiveElement) {
      console.warn("Animated gradient: .interactive element not found");
      return;
    }

    // Store the mouse move handler so we can remove it later
    this.mouseMoveHandler = (event) => {
      this.tgX = event.clientX;
      this.tgY = event.clientY;
    };

    // Listen for mouse movement
    window.addEventListener("mousemove", this.mouseMoveHandler);

    // Start the animation loop
    this.move();
  },

  createGradientStructure() {
    // Create main gradient background container (styles defined in CSS)
    const gradientBg = document.createElement("div");
    gradientBg.className = "gradient-bg layout-full z-0";

    // Create gradients container (styles defined in CSS)
    const gradientsContainer = document.createElement("div");
    gradientsContainer.className = "gradients-container";

    // Create each gradient circle (styles defined in CSS)
    GRADIENT_CIRCLES.forEach((className) => {
      const circle = document.createElement("div");
      circle.className = className;
      gradientsContainer.appendChild(circle);
    });

    // Create interactive cursor-following bubble (styles defined in CSS)
    const interactive = document.createElement("div");
    interactive.className = "interactive";
    gradientsContainer.appendChild(interactive);

    // Assemble everything
    gradientBg.appendChild(gradientsContainer);

    // Insert at the beginning of the component element
    this.$el.insertBefore(gradientBg, this.$el.firstChild);
    this.gradientContainer = gradientBg;
  },

  move() {
    if (!this.interactiveElement) return;

    // Smooth easing: gradually move current position toward target
    this.curX += (this.tgX - this.curX) / 10;
    this.curY += (this.tgY - this.curY) / 10;

    // Get element dimensions for centering
    const rect = this.interactiveElement.getBoundingClientRect();

    // Update position (centered on cursor)
    this.interactiveElement.style.left = `${Math.round(this.curX - rect.width / 2)}px`;
    this.interactiveElement.style.top = `${Math.round(this.curY - rect.height / 2)}px`;

    // Continue animation loop
    this.animationFrameId = requestAnimationFrame(() => this.move());
  },

  destroy() {
    // Clean up: stop animation and remove event listener
    if (this.animationFrameId) {
      cancelAnimationFrame(this.animationFrameId);
    }
    if (this.mouseMoveHandler) {
      window.removeEventListener("mousemove", this.mouseMoveHandler);
    }
    // Remove gradient structure from DOM
    if (this.gradientContainer && this.gradientContainer.parentNode) {
      this.gradientContainer.parentNode.removeChild(this.gradientContainer);
    }
  },
});
